import Header from '../components/header'
import { Outlet, ScrollRestoration, useSearchParams } from 'react-router-dom'
import NavigationProvider from '../contexts/navigation-context'
import { useEffect, type JSX } from 'react'
import PageInfo from '../components/page-info'
import { useSyncFrameSize } from '../hooks/frame-size'
import BrandProvider from '../contexts/brand'
import ChatLoader from '../components/chat-loader'
import { Brand } from '../types/brand'
import BBTFavicon from '../assets/favicon/boatbiketours.png'
import InselhuepfenFavicon from '../assets/favicon/inselhuepfen.svg'
import KootstraFavicon from '../assets/favicon/kootstra.ico'
import { useFavicon, useTitle } from 'react-use'
import { useBrand } from '../hooks/brand'

const TITLES: Record<Brand, string> = {
  boatbiketours: 'Boat Bike Tours',
  inselhuepfen: 'Bike & Boat - Islandhopping - cycling holiday by the sea',
  kootstra: 'Kootstra Rad & Schiffsreisen Deutschland & Europa'
}

const FAVICONS: Record<Brand, string> = {
  boatbiketours: BBTFavicon,
  inselhuepfen: InselhuepfenFavicon,
  kootstra: KootstraFavicon
}

function BrandMeta (): undefined {
  const brand = useBrand()
  useTitle(TITLES[brand])
  useFavicon(FAVICONS[brand])
  return undefined
}

export default function Page ({ brand = 'boatbiketours' }: { brand?: Brand }): JSX.Element {
  useSyncFrameSize()
  const isDev = import.meta.env.DEV

  const [searchParams] = useSearchParams()

  useEffect(() => {
    const cid = searchParams.get('cid')
    if (cid !== null) {
      localStorage.setItem('cid', cid)
    }
  }, [searchParams])

  return (
    <BrandProvider brand={brand}>
      <BrandMeta />
      <div className='grid' data-brand={brand}>
        <div className='flex flex-col accent-brand-primary brand-inselhuepfen:font-open-sans'>
          <NavigationProvider>
            <ScrollRestoration />
            <Header />
            <main className='mb-16 lg:mb-8 frame:lg:mb-0'>
              <Outlet />
            </main>
            {isDev && <PageInfo />}
            <ChatLoader />
          </NavigationProvider>
        </div>
      </div>
    </BrandProvider>
  )
}
